/* globals Node */

/**
 * Helper methods for DOM manipulation
 */
export default class DOM {
  /**
   * Empties given Node element
   * @param {Element} elem
   */
  static empty (elem) {
    if (this.isNode(elem)) {
      elem.textContent = ''
    }
  }

  /**
   * Checks if given var is Node element
   * @param {Element} elem
   * @return {boolean}
   */
  static isNode (elem) {
    return typeof elem !== 'undefined' && elem.nodeType === Node.ELEMENT_NODE
  }

  /**
   * Hides given Node element
   * @param {Element} elem
   */
  static hide (elem) {
    //
  }

  /**
   * Injects HTML into the given Node element
   * @param {Element} elem
   * @param {String} html
   */
  static html (elem, html) {
    if (this.isNode(elem)) {
      this.empty(elem)
      elem.insertAdjacentHTML('beforeend', html)
    }
  }
}
